import { useState } from 'react';
import API from '../utils/api';

const ContactSection = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await API.post('/contact', form);
      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch {
      setStatus('error');
    }
    setLoading(false);
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-grid">
        <div className="contact-info reveal">
          <div className="section-label">
            <span style={{ color: 'rgba(201,168,76,0.8)' }}>Get In Touch</span>
          </div>
          <h2>Let's Start a Conversation</h2>
          <p>
            Whether you're curious about investing in yourself, the earth, stocks, or giving back — 
            we're here to guide you on your journey.
          </p>
          <div className="contact-detail">
            <div className="contact-detail-icon">✉</div>
            <span className="contact-detail-text">rootscompetitiveacademy@gmail.com</span>
          </div>
          <div className="contact-detail">
            <div className="contact-detail-icon">☎</div>
            <span className="contact-detail-text">+91 92475 22063</span>
          </div>
          <div className="contact-detail">
            <div className="contact-detail-icon">⌂</div>
            <span className="contact-detail-text">The Village Investors - Hyderabad, India</span>
          </div>
        </div>

        <div className="contact-form reveal reveal-delay-2">
          {status === 'success' && (
            <div style={{ 
              padding: '16px 20px', background: '#E8F5E9', color: '#2E7D32', 
              marginBottom: 20, borderLeft: '4px solid #4CAF50', fontSize: '0.9rem'
            }}>
              ✓ Your message has been sent successfully! We'll be in touch soon.
            </div>
          )}
          {status === 'error' && (
            <div style={{ 
              padding: '16px 20px', background: '#FFEBEE', color: '#C62828', 
              marginBottom: 20, borderLeft: '4px solid #F44336', fontSize: '0.9rem'
            }}>
              ✗ Something went wrong. Please try again.
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Your Name</label>
                <input 
                  type="text" 
                  value={form.name}
                  onChange={e => setForm({...form, name: e.target.value})}
                  placeholder="John Smith" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input 
                  type="email" 
                  value={form.email}
                  onChange={e => setForm({...form, email: e.target.value})}
                  placeholder="john@example.com" 
                  required 
                />
              </div>
            </div>
            <div className="form-group">
              <label>Subject</label>
              <input 
                type="text" 
                value={form.subject}
                onChange={e => setForm({...form, subject: e.target.value})}
                placeholder="How can we help you?" 
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea 
                rows="5"
                value={form.message}
                onChange={e => setForm({...form, message: e.target.value})}
                placeholder="Tell us about your investment goals..." 
                required
              />
            </div>
            <button type="submit" className="btn-gold" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
              {loading ? 'Sending...' : 'Send Message ✦'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
